export const NAMES_AND_PHOTO = 'names_and_photo';
export const PHONES = 'phones';
export const EMAIL = 'email';
export const OTHER_CONTACTS = 'other_contacts';
export const EXPERIENCE = 'experience';
